import { render, staticRenderFns } from "./NoAlternativeDecision.vue?vue&type=template&id=87d10642"
import script from "./NoAlternativeDecision.vue?vue&type=script&lang=js"
export * from "./NoAlternativeDecision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports